import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  width: 100%;
  height: auto;
`;

const ErrorText = styled.p`
  color: var(--cc_color_utility_destroy);
  font-size: var(--cc_size_text_s);
  font-weight: 500;
  margin: var(--cc_size_spacing_xs) 0 0;
`;

const TaskListError = ({ message }) => {
  return (
    <Container>
      <ErrorText>{message}</ErrorText>
    </Container>
  );
};

TaskListError.propTypes = {
  message: PropTypes.string,
};

export default TaskListError;
